import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { BorderGradient } from 'processhub-components-lib';
import { FiX } from 'react-icons/fi';
import FormInput from 'components/Project/Form/FormInput';
import IntegrationForm from './IntegrationForm';
import { IntegrationInterface } from './Integration';


interface IntegrationModalProps {
  isOpen: boolean;
  mode: string;
  formState: any;
  editedIntegrationId: string | null;
  integrations: IntegrationInterface[];
  setIntegrations: React.Dispatch<React.SetStateAction<IntegrationInterface[]>>;
  setMode: React.Dispatch<React.SetStateAction<string>>;
  handleClose: () => void;
  setFormState: (formState: any) => void;
  setEditedIntegrationId: React.Dispatch<React.SetStateAction<string | null>>;
}

const IntegrationModal: React.FC<IntegrationModalProps> = ({setEditedIntegrationId, mode, isOpen, handleClose, formState, editedIntegrationId, integrations, setIntegrations, setFormState,setMode }) => {



  return (
    <div>
      <Dialog.Root open={isOpen} onOpenChange={handleClose}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
          <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-[90vw] lg:w-[1024px] h-[70vh]">
            <BorderGradient className='rounded-lg flex flex-col h-full w-full'>
              <div className="bg-[#1A1A1A] rounded-lg p-6 relative text-white overflow-y-auto flex flex-col h-full">

                <button
                  onClick={handleClose}
                  className="absolute top-[28px] right-4 text-gray-400 hover:text-white"
                >
                  <FiX size={24} />
                </button>

                <h2 className='text-lg font-semibold'> {mode === "add" ? "Add" : "Edit"}  Integration</h2>

                <IntegrationForm

                  // initialData={editedData}
                  setEditedIntegrationId={setEditedIntegrationId}
                  mode={mode}
                  setMode={setMode}
                  formState={formState}
                  integrations={integrations}
                  editedIntegrationId={editedIntegrationId}
                  setIntegrations={setIntegrations}
                  handleClose={handleClose}
                  setFormState={setFormState} />




              </div>
            </BorderGradient>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  );
};

export default IntegrationModal;
